import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";

import generatedIntrospection from "~/graphql/fragment";
import { isIpad } from "~/utils/user_agent";

const getOperationNames = (body: string) => {
  try {
    const data = JSON.parse(body);
    if (Array.isArray(data)) {
      return data.map(
        (operation: { operationName: string }) => operation.operationName,
      );
    }
    return data.operationName;
  } catch {
    return null;
  }
};

/**
 * @see https://www.apollographql.com/docs/react/api/link/apollo-link-batch-http/#dynamic-uri
 */
const fetchWithOperationName = (
  uri: RequestInfo | URL,
  options?: RequestInit,
) => {
  const operationNames = getOperationNames(`${options?.body}`);
  return fetch(`${uri}?opname=${operationNames}`, options);
};

export const createApolloClient = () => {
  const httpLink = new HttpLink({
    uri: `${process.env.apiBaseUrl}/graphql`,
    fetch: fetchWithOperationName,
  });

  const authLink = new ApolloLink((operation, forward) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    operation.setContext(({ headers }: Record<string, any>) => {
      const contextHeader = {
        headers: {
          ...headers,
          "X-Pharms-Service": "reservation",
        },
      };

      if (isIpad()) {
        // kinesissToBigQueryでdevice判定してる処理を将来的にフロントに移す予定
        // iPadOSだけはdevice判定できないため、先に移した
        contextHeader["headers"]["X-Device-Type"] = "tablet";
      }

      return contextHeader;
    });

    return forward(operation);
  });

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.map(({ message, locations, path }) => {
        console.log(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
        );
      });
    }

    if (networkError) {
      console.log(`[Network error]: ${networkError}`);
    }
  });

  const cache = new InMemoryCache({
    possibleTypes: generatedIntrospection.possibleTypes,
  });

  return new ApolloClient({
    ssrMode: false,
    link: ApolloLink.from([errorLink, authLink, httpLink]),
    cache,
    headers: {},
    defaultOptions: {
      query: {
        errorPolicy: "all",
      },
    },
    connectToDevTools: true,
  });
};
